<ng-template>
  <ng-content select="[app-narrow-sidebar-nav-list-item]"></ng-content>
</ng-template>
